import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

// Actions
import { GetValidDelivery } from '../../../../actions/bookingTime'

// Utils
import { translation } from '../../../../utils/helpers'

import BookingTimesWrapper from '../../BookingTimes/Wrapper'

// Elements
import Button from '../../../elements/button'
import PanelHeader from '../../../elements/panelHeader'
import DropDown from '../../../elements/dropDown'
import DateTime from '../../../elements/datetime'
import Grid from '../../../elements/grid'

class DateActions extends Component {
  constructor (props) {
    super(props)

    this.renderDateChange = this.renderDateChange.bind(this)
  }

  renderDateChange (state, setState, saveBookingTime) {
    let department = this.props.auth.departmentType === 0 ? 'Paint' : 'Body'
    let orderId = this.props.orderId

    let section = (state[department] || {}).Delivery
    if (!section) return null

    let { ValidTimes, CanEdit, Date, Time } = section
    let disabled = state.isLoading || !CanEdit

    const formatTime = (time) => {
      return time.substring(0, 5)
    }

    const onChange = (e) => {
      let value, name, date, time
      if (e.target && e.target.name === 'Time') {
        // for time change
        name = e.target.name
        value = e.target.value
        time = value
        date = Date
      } else {
        // for date change
        value = e.format('YYYY-MM-DDTHH:mm:ss')
        name = 'Date'
        time = Time
        date = e.format('YYYY-MM-DDTHH:mm:ss')
      }

      let EditedBookingTime = {
        Date: date,
        Time: time,
        Department: department === 'Body' ? 1 : 0,
        OrderId: orderId,
        BookingTimeType: 2 // Delivery
      }

      // If date is changeing we need to validate and get valid times
      if (name === 'Date') {
        this.props.GetValidDelivery(EditedBookingTime).then(({ data }) => {
          setState({
            [department]: {
              ...state[department],
              Delivery: {
                ...state[department].Delivery,
                Date: data.Date,
                Time: data.Time,
                ValidTimes: data.ValidTimes
              }
            },
            EditedBookingTime: {
              ...EditedBookingTime,
              Date: data.Date,
              Time: data.Time
            }
          })
        }, () => window.toastr.error(translation('960'), translation('216')))
      } else {
        setState({
          [department]: {
            ...state[department],
            Delivery: {
              ...state[department].Delivery,
              [name]: value
            }
          },
          EditedBookingTime
        })
      }
    }

    const renderDate = () => {
      return (
        <Grid spacing={1} cols={[1, 'min-content']}>
          <DateTime
            size='m'
            inputProps={{ readOnly: true, disabled }}
            closeOnSelect
            dateFormat='DD-MM-YYYY'
            timeFormat={false}
            value={window.CustomDate(Date)}
            name='Date'
            onChange={onChange}
            disabled={disabled}
          />
          <DropDown size='m' name='Time' value={formatTime(Time)} onChange={onChange} disabled={disabled}>
            {ValidTimes && ValidTimes.map((val, index) => { return <option key={index} value={formatTime(val)}>{formatTime(val)}</option> })}
            {!ValidTimes && <option value={formatTime(Time)}>{formatTime(Time)}</option>}
          </DropDown>
        </Grid>
      )
    }

    let warningText = null
    if (this.props.item && Array.isArray(this.props.item.CarRentalAssignments) && this.props.item.CarRentalAssignments.length > 0) {
      warningText = translation(16822)
    }

    let classString = 'poppedup'
    if (this.props.location === 'orderlist') {
      classString += ' orderlist'
    } else if (this.props.location === 'assign') {
      classString += ' assign'
    }

    return (
      <div className={classString}>
        <div>
          <PanelHeader text={translation('193')} />
          {renderDate()}
          {<div className='warning'>{warningText}</div>}
          <Button size='m' onClick={_ => saveBookingTime(this.props.onSuccess)} labelText={translation('791')} />
        </div>
      </div>
    )
  }

  render () {
    return (
      <BookingTimesWrapper OrderId={this.props.orderId}>
        {this.renderDateChange}
      </BookingTimesWrapper>
    )
  }

}

DateActions.PropTypes = {
  orderId: PropTypes.number.isRequired,
  item: PropTypes.object, // If defined, used to determine if rentalcar warning should be displayed
  onSuccess: PropTypes.func, // If defined, called on successful save
  location: PropTypes.oneOf(['orderlist', 'assign'])
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  GetValidDelivery
})(DateActions)



// WEBPACK FOOTER //
// ./src/app/shared/components/DateChangePopup/DateActions/index.js